import NodeSystemIn from './node-system-in';

export default NodeSystemIn;
